import {
    GETPROVIDERTYPE_SUCCESS,
    GETPROVIDERTYPE_FAILED,
    RESET_GETPROVIDERTYPE,
    LOADING_GETPROVIDERTYPE,
    NETWORK_ERROR_GETPROVIDERTYPE
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminGetProviderTypeList = () => {
    return { type: RESET_GETPROVIDERTYPE };
};

const getProviderTypeAdminList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETPROVIDERTYPE });
    await adminServices
        .post("getProviderType", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetProviderTypesuccess(res.data));
                    break;
                default:
                    dispatch(adminGetProviderTypeFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETPROVIDERTYPE,
                payload: err
            });
        });
};


function adminGetProviderTypesuccess(data) {
    return {
        type: GETPROVIDERTYPE_SUCCESS,
        payload: data
    };
}
function adminGetProviderTypeFailed(data) {
    return {
        type: GETPROVIDERTYPE_FAILED,
        payload: data
    };
}

export { getProviderTypeAdminList, resetAdminGetProviderTypeList }